<template>
  <div class="row justify-content-center">
    <div class="col-lg-6">
      <div class="card">
        <div class="card-body">
          <table class="form-table">
            <colgroup>
              <col />
              <col />
              <col style="width: 1%; white-space: nowrap;"/>
            </colgroup>
            <thead>
                <th>Staff ID</th>
                <th>Staff Name</th>
                <th class="action-checkbox"><input type="checkbox" @change="toggleAttendance" /></th>
            </thead>
            <tbody>
                <tr v-for="(data, index) in attendancedata" :key="index">
                    <td>{{data.staffid}}</td>
                    <td>{{data.staffname}}</td>
                    <td><input type="checkbox" v-model="selectedstaffs" :value="data.staffcode" :checked="data.status === null? false: data.status === 1? true: false"/></td>
                </tr>
            </tbody>
          </table>
          <div>
            <a-button type="primary" @click="handleClick">Update Attendance</a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'singleUpdateElement',
  props: {
    attendancedata: { type: Array, required: true },
    date: { type: String, required: true },
  },
  mounted: function() {
    window.notify_local = this.$notification
  },
  data: function() {
    return {
      allstaffs: [],
      selectedstaffs: [],
    }
  },
  watch: {
    attendancedata(n, o) {
      console.log('attendance data props value')
      console.log(n, o)
      this.allstaffs = n.map(function(e) {
        return e.staffcode
      })
      this.selectedstaffs = n.map(function(e) {
        if (e.status === 1) {
          return e.staffcode
        }
      })
      this.selectedstaffs = this.selectedstaffs.filter(function(e) { return e != null })
      console.log('all staffs', this.allstaffs)
      console.log('preselected staffs', this.selectedstaffs)
    },
  },
  methods: {
    toggleAttendance: function(e) {
      console.log('toggle attendance')
      console.log(e.target.checked)
      if (e.target.checked) {
        this.selectedstaffs = this.allstaffs
      } else {
        this.selectedstaffs = []
      }
    },
    handleClick: function() {
      console.log('selected staffs', this.selectedstaffs)
      var ts = this.selectedstaffs
      var cdate = this.date
      let updatedata = this.allstaffs.map(function(e) {
        return { staff_id: e, date: cdate, status: ts.some(function (d) { return d === e }) ? 1 : 0 }
      })
      console.log('updatedata', updatedata)
      // posting data
      let readydata = { staff_attendances: updatedata }

      console.log('readydata', readydata)
      this.$http.post('/api/staff/attendance/manual/entry', readydata)
        .then(function(data) {
          console.log('data sent', data)
          if (data.status === 200) {
            window.notify_local.open({
              message: 'Success',
              description: 'Staff attendance has been successfully updated!',
            })
          }
        }).catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>

<style>
table.form-table {
    width: 100%;
    margin-left: auto; margin-right: auto;
    margin-bottom: 25px;
}

table.form-table tbody tr td, table.form-table thead th {
    padding: 5px;
    border-bottom: 1px solid #ddd;
}

table.form-table thead th:first-child {
    width: 90px;
}
</style>
